<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('error-pages::page.title.error_pages') }}</h2>

            <div>
                <b-datatable
                    :key="datatableKey"
                    :endpoint="listRoute"
                    :columns="columns"
                    :hidden-columns="hiddenColumns"
                    has-filter-selector
                    item-key="id"
                    :multi-sort="false"
                >
                    <template #filters="{ filters }">
                        <v-col cols="4" class="pb-0">
                            <b-filter-input
                                v-model="filters.filters.file_name"
                                :label="t('error-pages::grid.label.file_name')"
                            ></b-filter-input>
                        </v-col>
                        <v-col cols="4" class="pb-0">
                            <b-filter-input
                                v-model="filters.filters.http_status"
                                :label="t('error-pages::grid.label.http_status')"
                            ></b-filter-input>
                        </v-col>
                        <v-col cols="4" class="pb-0">
                            <b-filter-select
                                v-model="filters.filters.is_active"
                                :items="filterItems"
                                item-text="label"
                                item-value="value"
                                :clearable="filters.filters.is_active !== null"
                                :placeholder="t('error-pages::grid.label.is_active')"
                            >
                            </b-filter-select>
                        </v-col>
                    </template>

                    <template #[`item.allowed_for_guests`]="{ item }">
                        <div class="grid-status">
                            <span>
                                {{ item.allowed_for_guests ? t('default::label.yes') : t('default::label.no') }}
                            </span>
                        </div>
                    </template>

                    <template #[`item.allowed_for_all`]="{ item }">
                        <div class="grid-status">
                            <span>
                                {{ item.allowed_for_all ? t('default::label.yes') : t('default::label.no') }}
                            </span>
                        </div>
                    </template>
                    <template #[`item.is_active`]="{ item }">
                        <div class="grid-status">
                            <span>
                                {{ item.is_active ? t('default::status.active') : t('default::status.inactive') }}
                            </span>
                        </div>
                    </template>
                    <template #buttons>
                        <div class="px-2">
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        v-if="can('error-pages.create')"
                                        color="primary"
                                        icon
                                        v-bind="attrs"
                                        :href="getCreateUrl()"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('error-pages::button.create.new_error_page') }}</span>
                            </v-tooltip>
                        </div>
                    </template>
                    <template #[`item.actions`]="{ item }">
                        <div class="table-actions">
                            <v-tooltip v-if="can('api.v1.error-pages.update')" top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        color="disabled-color"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="$root.goTo(editItemUrl(item))"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.edit') }}</span>
                            </v-tooltip>
                            <b-delete
                                v-if="can('api.v1.error-pages.destroy')"
                                :title="t('default::confirmation.general')"
                                :text="t('default::confirmation.deletion')"
                                icon="mdi-trash-can"
                                :path="deleteItemUrl(item)"
                                @deleted="triggerDeleted"
                            >
                            </b-delete>
                        </div>
                    </template>
                </b-datatable>
            </div>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            datatableKey: 0,
            hiddenColumns: ['id'],
            filterItems: [
                { label: t('default::label.all'), value: null },
                { label: t('default::label.active'), value: 1 },
                { label: t('default::label.inactive'), value: 0 },
            ],
            columns: [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('error-pages::grid.label.file_name'),
                    value: 'file_name',
                    sortable: true,
                    width: 100,
                },
                {
                    text: t('error-pages::grid.label.http_status'),
                    value: 'http_status',
                    sortable: true,
                    width: 100,
                },
                {
                    text: t('error-pages::grid.label.is_active'),
                    value: 'is_active',
                    sortable: false,
                    width: 100,
                },
                {
                    text: t('default::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: null,
                    align: 'end',
                    width: 140,
                },
            ],
        };
    },
    methods: {
        getCreateUrl() {
            return route('error-pages.create');
        },
        editItemUrl(item) {
            return route('error-pages.get', { error_page: item.id });
        },
        deleteItemUrl(item) {
            return route('api.v1.error-pages.destroy', { error_page: item.id });
        },
        triggerDeleted() {
            this.datatableKey++;
            this.$root.notify('info', t('default::notification.deleted'));
        },
    },
};
</script>
